<template>
  <div v-if="$store.getters.loading"></div>
  <div v-else>
    <DataTable :headers="headers" :path="path" :filterPath="filterPath" :properties="properties"
      action-buttons-name="ExpedienteListActionButtons" filter toolbar toolbar-title="Expedientes"
      search-text="Buscar número de expediente o título" :hasCustomColorRow="true">
    </DataTable>
    <v-btn v-if="$store.state.permissions.canAddExpediente" app dark fixed fab bottom right class="add-button"
      @click="createExpediente">
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'
const CLUB_INDEX_IN_TABLE = 1

export default {
  components: {
    DataTable
  },

  data () {
    return {
      path: 'expedientes',
      filterPath: 'filters/expedientes'
    }
  },

  computed: {
    headers () {
      let headers = [
        { text: 'Número de expediente', value: 'code' },
        { text: 'Tipo', value: 'type', filterField: true },
        { text: 'Estado', value: 'state', filterField: true },
        { text: 'Partido', value: 'match' },
        { text: 'Título', value: 'description' },
        { text: 'Fecha de apertura', value: 'created' },
        { text: 'Última modificación', value: 'modified', align: 'left' },
        { text: 'Desde Apertura', value: 'fromDate', sortable: false, align: 'left', dateFilterField: true, visible: false },
        { text: 'Hasta Apertura', value: 'toDate', sortable: false, align: 'right', dateFilterField: true, visible: false },
        { text: 'Acciones', align: 'right', sortable: false }
      ]
      if (this.$store.getters.isSafRole) {
        headers.splice(CLUB_INDEX_IN_TABLE, 0, { text: 'Club', value: 'club', sortable: false, filterField: true })
      }
      return headers
    },
    properties () {
      let properties = ['code', 'type', 'state', 'match', 'description', 'created', 'modified']
      if (this.$store.getters.isSafRole) {
        properties.splice(CLUB_INDEX_IN_TABLE, 0, 'club')
      }
      return properties
    }
  },

  methods: {
    createExpediente () {
      this.$router.push({ name: 'nuevoExpediente' })
    }
  }
}
</script>
